import { useAppSelector } from "store/hooks";
import { isSmallScreen, sidebarState, userSettingState } from "store/selectors";
import { PropsWithChildren, useEffect } from "react";
import { findSidebarWidth } from "./helper";
import styles from "./styles.module.css";

type ContainerPropTypes = {
  classes?: string;
};

export function Container({
  children,
  classes = "",
}: PropsWithChildren<ContainerPropTypes>) {
  const sidebarCollapsedState = useAppSelector(sidebarState);
  const { isDarkMode } = useAppSelector(userSettingState);
  const smallScreen = useAppSelector(isSmallScreen);

  useEffect(() => {
    function handleContainerHeight() {
      const mainContainer = document.getElementById("main-container");
      const windowWidth = window?.innerWidth;
      if (mainContainer) {
        const offsets = mainContainer.getBoundingClientRect();

        mainContainer.style.height = window.innerHeight - offsets.top + "px";

        if (!smallScreen) {
          if (sidebarCollapsedState) {
            mainContainer.style.maxWidth = windowWidth - 80 + "px";
          } else {
            const sidebarWidth = findSidebarWidth();
            mainContainer.style.maxWidth = windowWidth - sidebarWidth + "px";
            // mainContainer.style.maxWidth = windowWidth - 80 + "px";
          }
        } else {
          mainContainer.style.maxWidth = windowWidth + "px";
        }
      }
    }
    window.addEventListener("resize", handleContainerHeight);

    sidebarCollapsedState && handleContainerHeight();

    const timeout = setTimeout(() => {
      handleContainerHeight(); // Run on component mount
    }, 300);

    return () => {
      window.removeEventListener("resize", handleContainerHeight); // Cleanup
      clearTimeout(timeout);
    };
  }, [sidebarCollapsedState, smallScreen]);

  const layoutContainerClasses = `${styles.container} ${classes || ""} ${
    isDarkMode ? styles.darkModeStyle : ""
  } ${classes}`;

  return (
    <div className={layoutContainerClasses} id="main-container">
      {children}
    </div>
  );
}
